import { format, isValid, parse } from 'date-fns';

import type { Profile } from '../../profile.types';
import type { IdentityFormState } from './useEditIdentityPanel.types';

import { normalizeDateToLocalDateOnly } from '../../utils/normalize-date/normalizeDate';

function buildInitialFormState(profile?: Profile): IdentityFormState {
  return {
    salutation: profile?.salutation ?? '',
    givenName: profile?.givenName ?? '',
    middleName: profile?.middleName ?? '',
    lastName: profile?.lastName ?? '',
    birthdate: normalizeDateToLocalDateOnly(profile?.birthdate),
  };
}

function toIsoDateOnly(date: Date): string {
  return isValid(date) ? format(date, 'yyyy-MM-dd') : '';
}

function parseBirthdateInput(raw: string): Date | null {
  if (raw.length !== 10) return null;
  const parsed = parse(raw, 'dd-MM-yyyy', new Date());
  if (!isValid(parsed)) return null;
  // Normalize to midnight to match normalizeDateToLocalDateOnly's output,
  // preventing false dirty state when a user retypes their existing birthdate.
  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
}

export { buildInitialFormState, parseBirthdateInput, toIsoDateOnly };
